// MEGA MENU HOVER FUNCTIONALITY
// Reviewed and modified by Gemini Pro 3.1 Pro Extended (06/07/2026)

// Only run this script if the user's primary input mechanism can hover (e.g., has a physical mouse).
// This perfectly protects touch-only devices (like iPads/tablets) that might display the desktop menu but lack a mouse.
if (window.matchMedia('(hover: hover)').matches) {
  
  // Constants for timing
  const HOVER_DELAY_CLOSE = 300; // Gives users time to move from the link into the dropdown
  const HOVER_DELAY_OPEN = 100;  // Prevents menus from flashing open if the user quickly swipes the mouse across the nav

  // Target all header details elements (the wrapper for the dropdowns)
  const megaMenuDetails = document.querySelectorAll('.header__inline-menu details');

  megaMenuDetails.forEach((details) => {
    const summary = details.querySelector('summary'); // The clickable/hoverable link text
    let closeTimeout = null;
    let openTimeout = null;

    // Function to handle opening the menu
    const openMenu = () => {
      // Stop any pending close actions
      clearTimeout(closeTimeout);
      
      // Add a tiny delay to ensure the user meant to hover here (intent)
      openTimeout = setTimeout(() => {
        
        // Instantly close any other open mega menus to keep the UI snappy
        megaMenuDetails.forEach((otherDetails) => {
          if (otherDetails !== details && otherDetails.hasAttribute('open')) {
            otherDetails.removeAttribute('open');
            otherDetails.querySelector('summary')?.setAttribute('aria-expanded', 'false');
          }
        });

        // Open the current menu and update screen reader attributes
        details.setAttribute('open', '');
        summary?.setAttribute('aria-expanded', 'true');
      }, HOVER_DELAY_OPEN);
    };

    // Function to handle closing the menu
    const closeMenu = () => {
      // If the mouse leaves before the open delay finishes, cancel the open action entirely
      clearTimeout(openTimeout); 
      
      // Start the countdown to close the menu
      closeTimeout = setTimeout(() => {
        details.removeAttribute('open');
        summary?.setAttribute('aria-expanded', 'false');
      }, HOVER_DELAY_CLOSE);
    };

    // --- 1. MOUSE LISTENERS ---
    // We attach these to 'details' so the menu stays open while moving the mouse inside the dropdown content
    details.addEventListener('mouseenter', openMenu);
    details.addEventListener('mouseleave', closeMenu);
    
    // --- 2. KEYBOARD & ACCESSIBILITY LISTENERS ---
    // Ensure the menu opens when a user hits 'Tab' to reach the link
    summary.addEventListener('focus', openMenu); 
    
    // Ensure the menu closes when the user tabs away from the dropdown entirely
    details.addEventListener('focusout', (e) => {
      // e.relatedTarget is where the focus is going next.
      // We only close if the user tabs to an element outside of this specific dropdown.
      if (!details.contains(e.relatedTarget)) {
        closeMenu();
      }
    });
    
    // --- 3. CLICK HANDLER FOR DESKTOP ---
    summary.addEventListener('click', (e) => {
      // e.detail tells us how the click happened. 
      // 0 = triggered by Keyboard (Enter/Space)
      // 1+ = triggered by an actual Mouse click
      // 
      // We prevent the default click action ONLY if it's a mouse click. 
      // This stops a mouse click from instantly closing a menu that hover just opened,
      // but it still allows keyboard users to toggle the menu open and closed normally.
      if (details.hasAttribute('open') && e.detail > 0) {
        e.preventDefault(); 
      }
    });
  });
}



// CART
// Custom cart behaviour, stop cart icon on header loading cart drawer, go to cart page instead
//document.addEventListener('DOMContentLoaded', function () {
//  const cartIcon = document.getElementById('force-cart-link');
//  if (cartIcon) {
//    cartIcon.addEventListener('click', function (event) {
//      event.preventDefault(); // Stop drawer
//      window.location.href = '/cart'; // Go to full cart page
//    });
//  }
//});




/**
 * ============================================================================
 * CUSTOM WISHLIST FRONTEND LOGIC
 * Made with Gemini 3.1 Pro Extended (05/07/2026)
 * ============================================================================
 * Handles clicking the add/remove buttons on product pages, and rendering 
 * the saved products grid on the dedicated wishlist page.
 */

document.addEventListener('DOMContentLoaded', () => {
  
  // 1. CONFIGURATION
  // Point this to your deployed Cloudflare Worker URL
  const WORKER_URL = 'https://wishlist.artedelux.com';

  // ==========================================================================
  // FEATURE A: TOGGLE WISHLIST BUTTON (POST)
  // ==========================================================================
  const wishlistButtons = document.querySelectorAll('.custom-wishlist-btn');

  wishlistButtons.forEach(button => {
    button.addEventListener('click', async (e) => {
      e.preventDefault();
      
      // Prevent rapid double-clicks while processing
      if (button.disabled) return;
      
      // Extract data embedded by Liquid
      const productId = button.dataset.productId;
      const customerId = button.dataset.customerId;
      const signature = button.dataset.signature;

      // Optimistic UI update: Disable button and show loading state
      button.disabled = true;
      const originalText = button.querySelector('.wishlist-text').innerText;
      button.querySelector('.wishlist-text').innerText = 'Saving...';

      try {
        // Send the toggle request to the Cloudflare Worker
        const response = await fetch(WORKER_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            productId: productId,
            customerId: customerId,
            signature: signature
          })
        });

        const data = await response.json();

        if (response.ok && data.success) {
          // Update the button text based on whether it was added or removed
          if (data.message === 'Added') {
            button.querySelector('.wishlist-text').innerText = 'Remove from Wishlist';
            button.classList.add('is-active'); // Useful for CSS styling (e.g., solid heart)
          } else {
            button.querySelector('.wishlist-text').innerText = 'Add to Wishlist';
            button.classList.remove('is-active'); // E.g., outline heart
          }
        } else {
          console.error("Wishlist Error:", data.error);
          button.querySelector('.wishlist-text').innerText = originalText;
          alert("Could not update wishlist. Please try again.");
        }
      } catch (error) {
        console.error("Network Error:", error);
        button.querySelector('.wishlist-text').innerText = originalText;
      } finally {
        // Re-enable the button
        button.disabled = false;
      }
    });
  });


  // ==========================================================================
  // FEATURE B: RENDER WISHLIST PAGE (GET)
  // ==========================================================================
  const wishlistGrid = document.getElementById('wishlist-results-grid');

  if (wishlistGrid) {
    // Extract data embedded by Liquid on the wishlist page
    const ids = wishlistGrid.dataset.ids;
    const customerId = wishlistGrid.dataset.customerId;
    const signature = wishlistGrid.dataset.signature;

    // Build the URL with query parameters
    const fetchUrl = `${WORKER_URL}/get-products?ids=${encodeURIComponent(ids)}&customerId=${encodeURIComponent(customerId)}&signature=${encodeURIComponent(signature)}`;

    // Fetch product details from the worker
    fetch(fetchUrl)
      .then(response => {
        if (!response.ok) throw new Error("Unauthorized or server error");
        return response.json();
      })
      .then(data => {
        // Clear the "Loading..." text
        wishlistGrid.innerHTML = '';

        if (!data.products || data.products.length === 0) {
          wishlistGrid.innerHTML = '<p>Your wishlist is currently empty.</p>';
          return;
        }

        // Loop through the returned products and build the HTML for each card
        data.products.forEach(product => {
          
          // Shopify GraphQL returns GIDs (gid://shopify/Product/12345). We need just the number.
          const cleanId = product.id.split('/').pop();
          const imageUrl = product.featuredImage ? product.featuredImage.url : 'https://cdn.shopify.com/s/images/themes/product-1.png';
          const price = product.priceRange.minVariantPrice;
          
          // You can customize this HTML block to match your theme's product card layout
          const productHTML = `
            <div class="grid__item" id="wishlist-item-${cleanId}">
              <div class="card-wrapper product-card-wrapper">
                <a href="/products/${product.handle}">
                  <img src="${imageUrl}" alt="${product.title}" loading="lazy" width="300" height="300" style="width: 100%; height: auto;">
                </a>
                <div class="card-information">
                  <h3 class="card__heading">
                    <a href="/products/${product.handle}">${product.title}</a>
                  </h3>
                  <div class="price">
                    ${price.amount} ${price.currencyCode}
                  </div>
                  <button class="button custom-wishlist-btn" data-product-id="${cleanId}" data-customer-id="${customerId}" data-signature="${signature}" style="margin-top: 10px; width: 100%;">
                    <span class="wishlist-text">Remove</span>
                  </button>
                </div>
              </div>
            </div>
          `;
          
          wishlistGrid.insertAdjacentHTML('beforeend', productHTML);
        });

        // Optional: Re-attach event listeners to the new "Remove" buttons we just generated dynamically
        // so users can remove items directly from the wishlist page without refreshing.
        attachDynamicRemoveListeners(wishlistGrid);
      })
      .catch(error => {
        console.error("Failed to load wishlist:", error);
        wishlistGrid.innerHTML = '<p>There was an error loading your wishlist. Please refresh the page.</p>';
      });
  }

  // Helper function to handle removing items directly from the wishlist page
  function attachDynamicRemoveListeners(container) {
    const dynamicButtons = container.querySelectorAll('.custom-wishlist-btn');
    dynamicButtons.forEach(button => {
      button.addEventListener('click', async (e) => {
        e.preventDefault();
        const productId = button.dataset.productId;
        button.disabled = true;
        button.querySelector('.wishlist-text').innerText = 'Removing...';

        try {
          const response = await fetch(WORKER_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              productId: productId,
              customerId: button.dataset.customerId,
              signature: button.dataset.signature
            })
          });

          if (response.ok) {
            // Remove the product card entirely from the DOM
            const card = document.getElementById(`wishlist-item-${productId}`);
            if (card) card.remove();
            
            // Show empty state if that was the last item
            if (container.children.length === 0) {
              container.innerHTML = '<p>Your wishlist is currently empty.</p>';
            }
          }
        } catch (error) {
          console.error("Error removing item:", error);
          button.disabled = false;
          button.querySelector('.wishlist-text').innerText = 'Remove';
        }
      });
    });
  }

});
